__turbopack_context__.v({
  "label": "-kMNZG_label",
  "laurel": "-kMNZG_laurel",
  "mirrored": "-kMNZG_mirrored",
  "proof": "-kMNZG_proof",
});
